import React, { FC } from 'react';
import { useTranslate } from 'react-admin';
import { l } from '~/utils/solutions';
import { useStyles } from '~/hooks/useSolutionsStyles';
import { JsonInput } from './JsonInput';

interface BeneficiaryFormProps {
  keyName: string;
}

export const BeneficiaryForm: FC<BeneficiaryFormProps> = ({ keyName }) => {
  const classes = useStyles();
  const translate = useTranslate();
  const t = (key: string): string => translate(l(`featuresConfig.${key}`));
  return (
    <>
      <JsonInput
        label={t('beneficiarySchema')}
        source={`${keyName}.beneficiarySchema`}
        className={classes.schemaInput}
        validationError={t('jsonError')}
      />
    </>
  );
};
